import axios from '../../helpers/axios-setup';
import { PUBLISHED } from '../../components/pages/test-case/data/constants';

export const updateTCState = ({ id, status }: { id: number | string; status: 'PUBLISHED' | 'ARCHIVED' }) =>
  axios.put(`/test-cases/${id}/${status === PUBLISHED ? 'publish' : 'archive'}`);
